import React from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import AssistantsInternshipsManagerView from '../../Views/MACCS/MaccsInternshipsManager/AssistantsInternshipsManagerView'
import AssistantProfilePage from '../../Components/MACCS/ProfilePage/AssistantProfilePage'
import { Routes } from '../../routes'

const AssistantRouter = () => {
  return (
    <Switch>
      <Route path={Routes.INTERNSHIPS}>
        <div className='inner-spacing'>
          <AssistantsInternshipsManagerView />
        </div>
      </Route>
      <Route path={Routes.PROFILE_PAGE}>
        <AssistantProfilePage />
      </Route>
    </Switch>
  )
}

export default withRouter(AssistantRouter)
